import React from 'react';
import { useTheme, Typography, Box, Stack } from '@mui/material';

const Home = () => {
  const theme = useTheme();

  return (
     <div className='home'>
      <div className='para'>
      <Typography
          variant="h5"
          color={theme.palette.secondary.sec}
          fontWeight="bold"
        >
          Искате да разберете реалната стойност на имота си?
        </Typography>

        <Typography variant="body1" color={theme.palette.secondary.other}>
          Нашата AI-базирана система за прогнозна оценка на имоти използва най-съвременни алгоритми за машинно обучение, за да ви даде точна, бърза и обективна оценка на базата на актуални пазарни данни. Това не е просто калкулатор – това е интелигентен инструмент, който учи и се подобрява всеки ден.
        </Typography>
        </div>
        <div className='para'>
        <Typography
          variant="h6"
          color={theme.palette.secondary.sec}
          fontWeight="bold"
        >
          Какво прави нашия модел толкова точен?
        </Typography>

        <Typography variant="body1" color={theme.palette.secondary.other}>
          Системата анализира ключови параметри като локация, тип на имота, площ, етажност, състояние, наличие на паркинг, асансьор и много други. Всеки детайл се превръща в числова стойност, което позволява на модела да прави прецизни и обосновани изчисления. Иновативната архитектура използва комбинация от „слаби“ модели, които постепенно намаляват грешките, за да изградят една силна и надеждна оценка.
        </Typography>
        </div>
        <div className='para'>
        <Typography
          variant="h6"
          color={theme.palette.secondary.sec}
          fontWeight="bold"
        >
          Надеждност, подкрепена с числа
        </Typography>

        <Typography variant="body1" color={theme.palette.secondary.other}>
          Нашата система предоставя прогнози с точност между 85% и 95%. Това е резултат от задълбочен анализ на хиляди имотни обяви и историята им на пазара. Благодарение на постоянния поток от нови данни, моделът става все по-добър – това означава, че с всяка изминала седмица получавате още по-точна оценка.
        </Typography>
        </div>
        <div className='para'>
        <Typography
          variant="h6"
          color={theme.palette.secondary.sec}
          fontWeight="bold"
        >
          Винаги актуални данни – всеки ден
        </Typography>

        <Typography variant="body1" color={theme.palette.secondary.other}>
          Пазарът на имоти се променя динамично – затова и ние го следим ежедневно. Системата автоматично обновява информацията, като анализира новите обяви и пазарни тенденции в реално време. Така може да сте сигурни, че всяка оценка е възможно най-близка до реалната цена в момента.
        </Typography>
        </div>
        <div className='para'>
        <Typography
          variant="h6"
          color={theme.palette.secondary.sec}
          fontWeight="bold"
        >
          Ползите за вас?
        </Typography>

        <Typography variant="body1" color={theme.palette.secondary.other}>
          Независимо дали продавате, купувате или просто се интересувате от стойността на имота си – нашата AI платформа ще ви даде конкурентно предимство. Вземайте информирани решения с увереност и точност.
          <br /><br />
          <strong>Направете първата стъпка – регистрирайте се сега и получете достъп до интелигентната прогнозна оценка на вашия имот.</strong>
        </Typography>
        </div>
        
     </div>
     
  );
};

export default Home;
